(function () {
  function initialise(root) {
    const scope = root && root.querySelectorAll ? root : document;

    const reveals = scope.querySelectorAll('[data-ls-reveal]:not([data-ls-reveal-ready])');
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
      );
      reveals.forEach((element) => {
        element.dataset.lsRevealReady = 'true';
        observer.observe(element);
      });
    } else {
      reveals.forEach((element) => element.classList.add('is-visible'));
    }

    scope.querySelectorAll('[data-ls-faq]:not([data-ls-faq-ready])').forEach((directory) => {
      directory.dataset.lsFaqReady = 'true';
      const input = directory.querySelector('[data-ls-faq-search]');
      const items = Array.from(directory.querySelectorAll('[data-ls-faq-item]'));
      const empty = directory.querySelector('[data-ls-faq-empty]');
      if (!input) return;

      input.addEventListener('input', () => {
        const query = input.value.trim().toLocaleLowerCase();
        let visible = 0;
        items.forEach((item) => {
          const haystack = item.textContent.toLocaleLowerCase();
          const match = !query || haystack.includes(query);
          item.hidden = !match;
          if (match) visible += 1;
        });
        if (empty) empty.classList.toggle('is-visible', visible === 0);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise(document), { once: true });
  } else {
    initialise(document);
  }

  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
